import Router from './Router.svelte';

export default new Router({
	target: document.body,
	props: {}
});